// LoadingScreen.tsx
import React from "react";
import styles from "./Shadow.module.css";
// Note: this import style requires SVGR support (Create React App, Vite with vite-plugin-svgr, etc).
// If your build doesn't support `ReactComponent`, use <img src={...} /> fallback below.
import { ReactComponent as CPN } from "../../assets/images/CPN.svg";

type Props = {
  text?: string;
};

const LoadingScreen: React.FC<Props> = ({ text = "Loading..." }) => {
  return (
    <div className={styles.loadingOverlay} role="status" aria-live="polite">
      <div className={styles.loaderContainer}>
        <div className={styles.logoWrap}>
          <CPN className={styles.cpnLogo} aria-hidden="true" />
        </div>

        <div className={styles.label} aria-hidden="true">
          {text}
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
